import '../../node_modules/@splidejs/splide/dist/css/splide.min.css';
import '../sass/style.scss';

import {StickyHeader} from './stickyHeader';
import {TopScroller} from './topScroller';
import {Accordion} from './accordion';
import {Tab} from './tab.js';
import MobileDetect from 'mobile-detect';
import {SliderManager} from './sliders';
import {Offcanvas} from './offcanvas';
import {TabbedAccordion} from './tabbed-accordion';
import {ProjectFilter} from './projectFilter';

const stickyHeader = new StickyHeader();
stickyHeader.init();

// Check if it's a mobile device and apply accordion behavior
const isMobileDevice = () => {
    const md = new MobileDetect(window.navigator.userAgent);
    return md.mobile() !== null;
};

if (isMobileDevice()) {
    const accordion = new Accordion();
    accordion.init();
}

const topScroller = new TopScroller('.top', 1500);
topScroller.init();

new SliderManager();

// Offcanvas menu
new Offcanvas();

// Tabbed accordion
new Tab();
Array.from(document.querySelectorAll('.accordion')).map(element => new TabbedAccordion(element));

if (document.querySelector('.projects__filter-title')) {
    document.querySelector('.projects__filter-title').addEventListener('click', e => {
        document.querySelector('.projects__filter-title').classList.toggle('active');
        document.querySelector('.projects__filter .sector-list').classList.toggle('active');
    })

}


document.addEventListener('DOMContentLoaded', () => {
    const projectContainer = document.querySelector('.projects__list');
    const projectFilter = new ProjectFilter(projectContainer, 18);
    projectFilter.init();
});

// jQuery(window).scroll(function(){
//     jQuery(".fixed-div").css("opacity", 1 - jQuery(window).scrollTop() / 350);
// });

jQuery( document ).ready(function() {
    setTimeout(function() {
        jQuery("#envirabox-close").insertAfter("#envirabox-overlay");
        jQuery("#envirabox-left").insertAfter("#envirabox-overlay");
        jQuery("#envirabox-right").insertAfter("#envirabox-overlay");
    }, 1000);

    
});